import React, { useEffect } from "react";
import { Box, Typography, Stack, Button } from "@mui/material";
import PageHeader from "../../components/PageHeader";
import { Images } from "./../../assets/common";
import LockIcon from "@mui/icons-material/Lock";
import IosSwitch from "../../components/IOSSwitch";
export default function PayForNft() {
  const [checked, setChecked] = React.useState(false);

  const handleChange = (value) => {
    setChecked(value);
  };
  useEffect(() => {
    //console.log(checked);
  }, [checked]);
  return (
    <Box>
      <PageHeader noBack={true} title="Pay for Nft" close={true} />
      <Box sx={{ padding: "0 18px 0 18px" }}>
        <Stack
          alignItems="center"
          sx={{ width: "fit-content", margin: "auto" }}
        >
          <Typography
            style={{ fontSize: "48px", lineHeight: "44px", fontWeight: "bold" }}
          >
            $10.00
          </Typography>
          <Typography sx={{ display: "flex", marginLeft: "auto" }}>
            50 SIKI Coins
          </Typography>
        </Stack>
        <Box
          sx={{
            background: "#262626",
            borderRadius: "6px",
            padding: "15px",
            marginTop: "16px",
          }}
        >
          <Stack spacing={2}>
            <Stack direction="row">
              <img
                style={{ width: "52px", height: "52px" }}
                src={Images.coin}
                alt="logo"
              />
              <Stack ml="30px">
                <Typography
                  className="__logo_title"
                  sx={{ fontSize: "30px !important" }}
                >
                  200
                </Typography>
                <Typography
                  sx={{ fontFamily: '"Anton", sans-serif ', fontSize: "13px" }}
                >
                  Available SIKI Coin
                </Typography>
              </Stack>
            </Stack>
            <Button variant="contained" color="primary">
              Pay with SIKI Coins
            </Button>
            <Typography style={{ color: "#F48706", fontSize: "14px" }}>
              Pay with SIKI coins and get 50% discount.
            </Typography>
          </Stack>
        </Box>
        <Box
          sx={{
            border: "2px dashed #4D4D4D",
            padding: "15px 10px",
            borderRadius: "15px",
            marginTop: "60px",
          }}
        >
          <Stack
            direction="row"
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              padding: "10px 16px",
              width: "auto",
              backgroundColor: "#262626",
              borderRadius: "25px",
              alignItems: "center",
            }}
          >
            <LockIcon />
            <Typography sx={{ color: "#FFFFFF", fontSize: 17 }}>
              Make asset private
            </Typography>
            <IosSwitch checked={checked} handleChange={handleChange} />
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
